import gql from 'graphql-tag';
import { locationFieldsFragment } from './locationFieldsFragment';
import { participantFieldsFragment } from './participantFieldsFragment';
import { sanityDocumentFieldsFragment } from './sanityDocumentFieldsFragment';
import { sessionFieldsFragment } from './sessionFieldsFragment';

export const scheduledSessionFieldsFragment = gql`
  fragment AdminScheduledSessionFields on ScheduledSession {
    ... on SanityDocument {
      ...AdminSanityDocumentFields
    }
    status
    assignedUser
    session {
      _ref
    }
    location {
      _ref
    }
    datetime
    reference
    loginCode
    participants {
      _ref
    }
    options {
      allQuestionsInEvaluationShownByDefault
      enableAutoPauseOnHelpRequest
    }
    autoAdvance
    rSession {
      ...AdminSessionFields
    }
    rLocation {
      ...AdminLocationFields
    }
    rParticipants {
      ...AdminParticipantFields
    }
    unlockableParticipantIds
  }

  ${sanityDocumentFieldsFragment}
  ${sessionFieldsFragment}
  ${locationFieldsFragment}
  ${participantFieldsFragment}
`;
